import { BiSolidUpArrow, BiSolidDownArrow } from 'react-icons/bi'
import { useTheme } from 'styled-components'
import styled from 'styled-components'

export const FortuneArrow = ({
  fortuneEvolution,
  inverted,
}: {
  fortuneEvolution: string,
  inverted?: boolean
}) => {
  const theme = useTheme()

  return (
    <Container>
      {['up', 'down'].includes(fortuneEvolution) && <Content>
      {fortuneEvolution === 'up' ? (
        <BiSolidUpArrow color={theme.colorMain} />
      ) : fortuneEvolution === 'down' ? (
        <BiSolidDownArrow color={theme.colorMain} />
      ) : null}
      </Content>}
    </Container>
  )
}

const Container = styled.div`
  font-size: 0.5em;
  display: inline-block;
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
`

const Content = styled.div`
margin-right: 10px;
`